module.exports = __webpack_public_path__ + "assets/img/1693ae107d1b5ca6c25f9fcd43d00e05.svg";